import apolloClient from 'api/apolloClient';
import {
  GET_CONFIGURABLE_EMAILS,
  GET_EMAILS_BY_PERIOD_ID,
  GET_EMAILS_BY_RANGE,
  GET_EMAIL_TYPES,
  GET_SEND_GRID_CONTEXT,
  SAVE_CONFIGURABLE_EMAILS_FOR_USER,
} from 'api/emailService';
import { FetchResult } from 'apollo-link';
import { makeAutoObservable } from 'mobx';
import { ConfigurableEmailInfo, Email, EmailMapping, GeneralStatus, SendGridContext } from 'types/emailService';
import { PaginationDTO } from 'types/general';

export interface ConfigurableEmails {
  emails: ConfigurableEmailInfo[];
  emailsForUser: string[];
}

export class EmailStore {
  // eslint-disable-next-line class-methods-use-this
  async getEmailsByPeriodId(periodId: string): Promise<EmailMapping[]> {
    const result = await apolloClient.query<{ getEmailsByPeriodId: EmailMapping[] }>({
      query: GET_EMAILS_BY_PERIOD_ID,
      fetchPolicy: 'no-cache',
      variables: { periodId },
    });
    return result.data.getEmailsByPeriodId;
  }

  // eslint-disable-next-line class-methods-use-this
  async getEmailsByRange(
    from: string,
    to: string,
    sponsorId: string,
    emailType: string,
    status: GeneralStatus | null,
    page: number,
    email = '',
  ): Promise<PaginationDTO<Email>> {
    const res = await apolloClient.query<{ getEmailsByRange: PaginationDTO<Email> }>({
      query: GET_EMAILS_BY_RANGE,
      fetchPolicy: 'no-cache',
      variables: { from, to, domainId: sponsorId, emailType, status, page, email },
    });
    return res.data.getEmailsByRange;
  }

  // eslint-disable-next-line class-methods-use-this
  async getEmailTypes(): Promise<string[]> {
    const res = await apolloClient.query<{ getEmailTypes: string[] }>({
      query: GET_EMAIL_TYPES,
    });
    return res.data.getEmailTypes;
  }

  // eslint-disable-next-line class-methods-use-this
  async getSendGridContext(id: string): Promise<SendGridContext> {
    const res = await apolloClient.query<{ getSendGridContext: SendGridContext }>({
      query: GET_SEND_GRID_CONTEXT,
      fetchPolicy: 'no-cache',
      variables: { id },
    });
    return res.data.getSendGridContext;
  }

  // eslint-disable-next-line class-methods-use-this
  public async getConfigurableEmails(): Promise<ConfigurableEmails> {
    const res = await apolloClient.query<{
      getConfigurableEmails: ConfigurableEmailInfo[];
      getConfigurableEmailsForUser: string[];
    }>({
      query: GET_CONFIGURABLE_EMAILS,
      fetchPolicy: 'no-cache',
    });
    return {
      emails: res.data.getConfigurableEmails,
      emailsForUser: res.data.getConfigurableEmailsForUser,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  saveConfigurableEmailsForUser(
    emailTypes: string[],
  ): Promise<FetchResult<{ saveConfigurableEmailsForUser: boolean }>> {
    return apolloClient.mutate<{ saveConfigurableEmailsForUser: boolean }>({
      mutation: SAVE_CONFIGURABLE_EMAILS_FOR_USER,
      variables: { emailTypes },
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
